/**
 * ActiveTrackView
 *
 * Content for a discipline track that is in care (ACTIVE, PA_EXPIRING, PA_EXPIRED). The PA facts,
 * plan of care, visits and next shift are on the status strip above (Overview v3); this view holds
 * the quick actions, which open chart sections through onNavigateTab (OV-08, OV-12: no URL paths).
 */
import React from 'react';
import { FileText, ClipboardList, Calendar } from 'lucide-react';
import type { Discipline } from './types';
import { DISCIPLINE_COLORS } from './types';

interface ActiveTrackViewProps {
  discipline:     Discipline;
  onNavigateTab?: (tab: string) => void;
}

const QUICK_ACTIONS = [
  { label: 'Charting',  icon: FileText,      tab: 'Charting' },
  { label: 'Care Plan', icon: ClipboardList, tab: 'Care Plan' },
  { label: 'Schedule',  icon: Calendar,      tab: 'Schedule' },
] as const;

const ActiveTrackView: React.FC<ActiveTrackViewProps> = ({ discipline, onNavigateTab }) => {
  const colors = DISCIPLINE_COLORS[discipline];
  if (!onNavigateTab) return null;
  return (
    <div className="grid grid-cols-3 gap-2">
      {QUICK_ACTIONS.map(({ label, icon: Icon, tab }) => (
        <button
          key={label}
          type="button"
          onClick={() => onNavigateTab(tab)}
          className={[
            'flex flex-col items-center gap-1 py-2 px-1 min-h-[44px] rounded-lg border text-xs font-medium transition-colors',
            `${colors.light} ${colors.border} ${colors.label} hover:opacity-80`,
          ].join(' ')}
        >
          <Icon className="w-4 h-4" aria-hidden="true" />
          {label}
        </button>
      ))}
    </div>
  );
};

export default ActiveTrackView;
